<template>
  <li>
    <div class="row">
      <div class="col-md-4 col-lg-3">
        <h2 class="truncate"><strong>{{ accountUser.profile.full_name }}</strong></h2>
      </div>
      <div class="col-md-4 col-lg-3">
        <p class="truncate">
          <i class="fa fa-at"></i>
          <a :href="`mailto:${accountUser.email}`">{{ accountUser.email }}</a>
        </p>
      </div>
      <div class="col-md-2 col-lg-2">
        <p class="truncate">
          <i class="fa fa-phone"></i>
          <a :href="`tel:${accountUser.mobile}`">{{ accountUser.mobile }}</a>
        </p>
      </div>
      <div class="col-md-2 col-lg-1">
        <p v-if="isDriver" class="truncate text-right"><span class="badge badge-primary">Driver</span></p>
      </div>
      <div class="col-md-12 col-lg-3">
        <div class="pull-right">
          <span class="status status-enabled" v-if="accountUser.active">Enabled</span>
          <span class="status status-disabled" v-else>Disabled</span>

          <router-link v-if="editingDifferentUser" :to="{ name: 'account.parent.users.edit', params: { id: user.id, childId: accountUser.id }}" v-show="$user.isEnabled" class="btn btn-circle btn-primary"><i class="fa fa-pencil"></i></router-link>
          <router-link v-else :to="{ name: 'account.users.edit', params: { childId: accountUser.id }}" v-show="$user.isEnabled" class="btn btn-circle btn-primary"><i class="fa fa-pencil"></i></router-link>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import { existingUser } from 'mixins/user'
  import { Roles } from 'utils/user'

  export default {
    props: ['accountUser'],
    mixins: [existingUser],

    computed: {
      isDriver () {
        return this.accountUser.role_id === Roles.DRIVER
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AccountUsersListItem.vue?5463fa99